import ExpandableTable from '../../../_shared/ExpandableTable'
import type { SimpleVehicleProps } from '../../../types/types'
import CarParkExpandedRow from './CarParkExpandedRow'
import { useChosenCompany, useUser } from '../../../../../../../context/UserProvider'
import type { ColumnDef, VisibilityState } from '@tanstack/react-table'

const getCarKey = (car: SimpleVehicleProps, index: number) =>
  car.accountNo || car.budgetNo || car.registrationNumber || `${index}`

type CarTableProps = {
  cars: SimpleVehicleProps[]
  resetExpanded: boolean
  columns: ColumnDef<SimpleVehicleProps, any>[]
  columnVisibility?: VisibilityState
  onColumnVisibilityChange?: (v: VisibilityState | ((old: VisibilityState) => VisibilityState)) => void
  tableMeta?: any
  openInfo?: (car: SimpleVehicleProps) => void
}

const CarTable = ({
  cars,
  resetExpanded,
  columns,
  columnVisibility,
  onColumnVisibilityChange,
  tableMeta,
  openInfo,
}: CarTableProps) => {
  const { user } = useUser()
  const company = useChosenCompany()

  return (
    <ExpandableTable<SimpleVehicleProps>
      data={cars}
      columns={columns}
      renderExpandedRow={(car) => <CarParkExpandedRow openInfo={openInfo} car={car} user={user} company={company} />}
      columnVisibility={columnVisibility}
      onColumnVisibilityChange={onColumnVisibilityChange}
      tableMeta={tableMeta}
      resetExpanded={resetExpanded}
      getRowId={getCarKey}
    />
  )
}

export default CarTable
